export const BRAND_NAME = 'Bottflow';

export const WHATSAPP_NUMBER = '50660637609';
export const WHATSAPP_DISPLAY = '+506 6063-7609';
export const WHATSAPP_MESSAGE = encodeURIComponent(
  'Hola Bottflow, me interesa una consulta sobre soluciones de tecnología y datos para mi empresa.'
);
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export const CALENDLY_URL =
  process.env.REACT_APP_CALENDLY_URL ||
  'https://calendly.com';

export const PLATFORM_BASE_URL =
  'https://klydra-prod-230744996381.us-central1.run.app';

export const PLATFORM_URL = `${PLATFORM_BASE_URL}/dashboard`;

export const CONTACT_EMAIL = 'ruben.oreamuno2000@gmail.com';
export const COMPANY_LOCATION = 'Costa Rica · Centroamérica';

export const SERVICE_OPTIONS = [
  'Datos e inteligencia de negocio',
  'Automatización de procesos',
  'Software a medida',
  'Integraciones y plataformas',
  'Consultoría tecnológica',
  'Otro / No estoy seguro',
];

export const URGENCY_OPTIONS = [
  { value: 'urgent', label: 'Urgente — necesito avanzar este mes' },
  { value: 'soon', label: 'Próximas 4–8 semanas' },
  { value: 'exploring', label: 'Explorando opciones' },
];

export const NAV_ITEMS = [
  { name: 'Qué hacemos', id: 'services' },
  { name: 'Resultados', id: 'outcomes' },
  { name: 'Proceso', id: 'process' },
  { name: 'Contacto', id: 'contact' },
];
